import { render, staticRenderFns } from "./TeacherToolbar.vue?vue&type=template&id=7f72f9f7"
import script from "./TeacherToolbar.vue?vue&type=script&lang=js"
export * from "./TeacherToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports